import {type Margin} from '@yandex-delivery/blocks'
import {isEqual} from '@yandex-delivery/utils'

import {appConfig} from 'src/shared/config'

import {PIN_HEIGHT, PIN_SIZE} from '../consts'
import type {Props} from './types'

export function getMarginWithPlacemarkOffset(margin: Margin): Margin {
  const [top = 0, right = 0, bottom = 0, left = 0] = margin || []

  return [top + PIN_HEIGHT, right + PIN_SIZE / 2, bottom, left + PIN_SIZE / 2]
}

export function shouldInitializeLocation(
  isRouteVisible: boolean,
  isOnlySourcePoint: boolean,
  sourcePointCoordinates: Props['sourcePointCoordinates'],
) {
  if (!isRouteVisible) return true
  if (!isOnlySourcePoint) return false
  return isEqual(sourcePointCoordinates, appConfig.location)
}
